export const loading = (state) => {
    return state.loading
}

export const online = (state) => {
    return state.online
}


